export default "__VITE_ASSET__4CLsF2l9__"